module.exports = __webpack_public_path__ + "img/question.ea03ec65.svg";